import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Member } from '~/types';

export type MemberState = {
    member: Member;
};

const initialState: MemberState = {
    member: {
        id: '',
        first_name: '',
        last_name: '',
        application_id: '',
        pending_answer: '',
        email: '',
        main_group: '',
        group_info: {
            group_name: '',
            group_description: '',
            image_url: '',
        },
        groups: [
            {
                main_group: '',
                other_groups: [],
            },
            {
                subgroup: [],
            },
        ],
        digital_member_status: {},
    },
};

export const memberSlice = createSlice({
    name: 'member',
    initialState,
    reducers: {
        setMember: (state, action: PayloadAction<MemberState>) => {
            state.member = action.payload.member;
        },
        setPendingAnswer: (state, action: PayloadAction<string>) => {
            state.member = {
                ...state.member,
                pending_answer: action.payload,
            };
        },
        clearMember: () => ({
            ...initialState,
        }),
    },
});

export const { setMember, clearMember, setPendingAnswer } = memberSlice.actions;

export default memberSlice.reducer;
